import type { GetEstimatesQueryParams } from '../../../types/estimate.js'

export const estimateKeys = {
  all: ['estimates'] as const,
  clientPassengers: (clientId: string) => ['client-passengers', clientId] as const,
  clientSearch: (query: string, clientType?: string) =>
    ['client-search', query, clientType ?? null] as const,
  detail: (estimateId: string) => ['estimate-detail', estimateId] as const,
  // Préfixé par `all` : le rangement/la sortie d'un devis envoie un mail, et
  // l'invalidation existante de la liste doit rafraîchir l'historique avec elle.
  emails: (estimateId: string) => ['estimates', 'emails', estimateId] as const,
  formData: (id: string) => ['estimate-form-data', id] as const,
  infoMinimal: (id: string) => ['estimate-info-minimal', id] as const,
  list: (params: GetEstimatesQueryParams) => ['estimates', 'list', params] as const,
}
